<template>
  <g>
    <g clip-path="url(#clip0_15_107)">
      <path
        d="M20 6.00018H10V11.0002C10 11.5502 9.55 12.0002 9 12.0002C8.45 12.0002 8 11.5502 8 11.0002V4.00018H13C13.55 4.00018 14 3.55018 14 3.00018V1.00018C14 0.450183 13.55 0.000183105 13 0.000183105H7C6.45 0.000183105 6 0.450183 6 1.00018V6.00018H4C2.9 6.00018 2 6.90018 2 8.00018V20.0002C2 21.1002 2.9 22.0002 4 22.0002H20C21.1 22.0002 22 21.1002 22 20.0002V8.00018C22 6.90018 21.1 6.00018 20 6.00018Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_107">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
